import React from 'react';
import { Box, Typography } from '@mui/material';
import NavBar from '../components/NavBar';
import { useAuth } from '../contexts/AuthContext';

const SettingsPage = () => {
  const { user } = useAuth();
  return (
    <>
      <NavBar user={user} />
      <Box sx={{ minHeight: '70vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default', p: 3 }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>Settings</Typography>
        <Typography variant="body1" color="text.secondary">Customizations and preferences coming soon.</Typography>
      </Box>
    </>
  );
};

export default SettingsPage; 